import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * A mapping between fill colors and fill color tones to text color tones. This ensures that text
 * contrasts appropriately against its background for readability while maintaining design
 * consistency.
 */ const fillToTextColor = {
    base: {
        none: 'gray',
        soft: 'gray',
        medium: 'gray',
        bold: 'gray'
    },
    ...mapValues(colors, (_, color)=>({
            none: color,
            soft: color,
            medium: 'gray',
            bold: 'gray'
        }))
};

export { fillToTextColor };
//# sourceMappingURL=fill-to-text-color.js.map
